import withLocalization from './withLocalization'

export default withLocalization
